import React from "react";
import "../../components/Dashboard.scss";
import SchoolMain from "./SchoolMain/main";

interface Props {
}

const SchoolPrivate: React.FC<Props> = () => {

    return (
        <div className="grid">
            <SchoolMain/>
        </div>
    );
};

export default SchoolPrivate;
